import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/routing/PrivateRoute';
import GlobalStyles from './styles/GlobalStyles';

// Components
import Home from './components/Home';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Stream from './components/Stream';
import ViewStream from './components/ViewStream';
import Recordings from './components/Recordings';
import MeetingHistory from './components/MeetingHistory';

// Add this import with your other imports
import Calendar from './components/Calendar';

function App() {
  return (
    <AuthProvider>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/stream/:streamId" element={<Stream />} />
                  <Route path="/view/:streamId" element={<ViewStream />} />
                  <Route path="/recordings" element={<Recordings />} />
                  <Route path="/meeting-history" element={<MeetingHistory />} />
                  // Add this route inside your Routes component
                  <Route path="/calendar" element={<Calendar />} />
                </Routes>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;